@if (!activeGroup) {
<p class="mb-2 text-muted small">
    Selecciona un grupo de preguntas en la sección "Otros datos del asegurado principal".
</p>
}
@if (activeGroup) {
<form class="form-bloque-questions d-flex flex-column gap-3" [formGroup]="form">
    @for (q of visibleQuestions; track q?.id) {
    <div class="card border-0 shadow-sm">
        <div class="card-body p-3">
            <div class="d-flex justify-content-between align-items-start gap-3">
                <div>
                    <div class="fw-semibold">
                        {{ q.title }}
                        @if (q.required) { <span class="text-danger ms-1">*</span> }
                    </div>
                    @if (q.description) {
                    <div class="text-muted small mt-1">{{ q.description }}</div>
                    }
                </div>
                @if (q.type === QuestionType.Bool || q.type === QuestionType.Conditional) {
                <div class="border-start ps-3 d-flex align-items-center gap-3">
                    <div class="form-check form-switch d-flex align-items-center gap-2 m-0">
                        <input class="form-check-input" type="checkbox" [id]="'q_bool_'+q.id"
                            [formControlName]="qKey(q.id!)">
                    </div>
                </div>
                }
            </div>
            @if (q.type === QuestionType.Text) {
            <div class="mt-3">
                <div class="form-floating">
                    <input type="text" class="form-control focus-ring focus-ring-light" [id]="'q_text_'+q.id"
                        placeholder=" " [formControlName]="qKey(q.id!)">
                    <label [for]="'q_text_'+q.id">
                        {{ q.title }}
                        @if (q.required) { <span class="text-danger ms-1">*</span> }
                    </label>
                </div>
                @if (form.get(qKey(q.id!))?.touched && form.get(qKey(q.id!))?.invalid) {
                <div class="text-danger small mt-1">Este campo es requerido</div>
                }
            </div>
            }
            @if (q.type === QuestionType.File) {
            <div class="mt-3">
                @if (getSelectedFileName(q.id!)) {
                <div class="border rounded-3 p-2 d-flex justify-content-between align-items-center bg-light">
                    <span class="d-flex align-items-center gap-2 small text-truncate">
                        <span class="text-success">📎</span>
                        <strong class="text-truncate">{{ getSelectedFileName(q.id!) }}</strong>
                    </span>
                    <button (click)="removeFile(q.id!)"
                        class="btn btn-sm btn-outline-danger rounded-circle p-0 d-flex align-items-center justify-content-center"
                        style="width: 24px; height: 24px; font-size: 14px; line-height: 1;" type="button"
                        title="Quitar archivo">&times;</button>
                </div>
                @if (uploadStates.get(q.id!); as up) {
                @if (up.status === 'uploading') {
                <div class="mt-2">
                    <div class="progress" role="progressbar" aria-label="Subiendo archivo"
                        [attr.aria-valuenow]="up.progress" aria-valuemin="0" aria-valuemax="100" style="height: 6px;">
                        <div class="progress-bar bg-success" [style.width.%]="up.progress"></div>
                    </div>
                    <div class="text-muted small mt-1">Subiendo archivo... {{ up.progress }}%</div>
                </div>
                } @else if (up.status === 'done') {
                <div class="text-success small mt-1">Archivo cargado.</div>
                } @else if (up.status === 'error') {
                <div class="text-danger small mt-1 d-flex flex-wrap gap-2 align-items-center">
                    <span>{{ up.error }}</span>
                    <button type="button" class="btn btn-link btn-sm p-0 text-danger fw-semibold"
                        (click)="retryUpload.emit(q.id!)">Reintentar</button>
                </div>
                }
                }
                } @else {
                <input type="file" class="form-control" [id]="'q_file_'+q.id" accept=".jpg,.jpeg,.png,.webp,.heic,.pdf"
                    (change)="onFileChange(q.id!, $event)">
                <div class="text-muted small mt-1" style="font-size: 0.75rem;">Límite de tamaño: 40MB. Formatos
                    permitidos: .jpg, .png, .webp,
                    .heic, .pdf</div>
                @if (fileErrors.has(q.id!)) {
                <div class="text-danger small mt-1">{{ fileErrors.get(q.id!) }}</div>
                }
                @if (form.get(qKey(q.id!))?.touched && form.get(qKey(q.id!))?.invalid && !fileErrors.has(q.id!)) {
                <div class="text-danger small mt-1">Archivo requerido</div>
                }
                }
            </div>
            }
        </div>
    </div>
    }
</form>
}